import React, { useState, useEffect } from 'react';
import { useUserContext } from '../contexts/UserContext';

interface ValidationErrors {
  apiKey?: string;
  amountForEachTrade?: string;
}
const String_REGEX = /^[A-Za-z\s]+$/;
const Number_REGEX = /^[0-9\s]+$/;

const Profile: React.FC = () => {
  const {
    user
   } = useUserContext();
  const [apiKey, setApiKey] = useState("")
  const [apiSecret, setApiSecret] = useState("")
   const [amountForEachTrade, setAmountForEachTrade] = useState("")
   const [maxDailyLoss, setMaxDailyLoss] = useState("");
   const [error, setError] = useState('');
   const [validationErrors, setValidationErrors] = useState<ValidationErrors>({});
   const [isFormValid, setIsFormValid] = useState(false);
 
   // Validate form fields on input change
   useEffect(() => {
     const errors: ValidationErrors = {};
 
     //apiKey validation
     if (apiKey) {
       if (!String_REGEX.test(apiKey)) {
         errors.apiKey = 'API Key must contain only letters and numbers';
       }
     }
 
     //amountForEachTrade validation
     if (amountForEachTrade) {
       if (Number(amountForEachTrade) <= 0) {
         errors.amountForEachTrade = 'Amount must be greater than 0';
       } else if (!Number_REGEX.test(amountForEachTrade)) {
         errors.amountForEachTrade = 'Name must contain only letters and spaces';
       }
     }
 
     setValidationErrors(errors);
 
     // Check if form is valid (all fields have values and no validation errors)
     setIsFormValid(
       apiKey.trim() !== '' &&
       amountForEachTrade.trim() !== ''
     );
   }, [apiKey, amountForEachTrade]);
 
   const openInNewTab = () => {
     const newWindow = window.open(
       'https://www.binance.com/en/support/faq/detail/96dde1d806a44a67924f322f4f8092f6',
       '_blank',
       'noopener,noreferrer'
     );
     if (newWindow) newWindow.opener = null;
   };
 
   const saveBotConfig = async (e: React.FormEvent) => {
     e.preventDefault();
     setError('');
     // Double-check validation before submission
     if (!isFormValid) {
       setError('Please correct all validation errors before submitting');
       return;
     }
     try {
       const response = await fetch(process.env.REACT_APP_SERVER_URL + "/api/dashboard/saveBotConfig", {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({ apiKey, amountForEachTrade }),
       });
       const data = await response.json();
 
       if (!response.ok) {
         alert("Error")
       }
     } catch (err) {
       setError('An error occurred while saving Bot Config');
       console.error(err);
     }
   }
 


  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <main className="flex-1 p-0">
        <header className="mb-6">
          <h1 className="text-2xl font-bold">{user.name}</h1>
            <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, color: 'gray' }}>{user?.email}</h1>
 <div style={{textAlign : "center",display: 'flex', maxWidth : "fit-content" }}
                  className={`mt-2 px-3 py-1 rounded-full text-xs font-medium ${
                    user.pricing === 'Free'
                      ? 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200'
                      : user.subscriptionPlan === 'Pro'
                        ? 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200'
                        : 'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200'
                  }`}
                >
                  {user.pricing} Plan
                </div>
                 <h1 className="text-xs" style={{ margin: 0, paddingTop: 5, color: 'gray' }}>Subscription till: {new Date(user?.subscriptionFreeUntil).toLocaleString(undefined, { hour12: true })}</h1>

        </header>

   

   


      {user.pricing == "Basic" ?
        <div className="lg:col-span-3">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6" style={{ display: "flex", flexDirection: "row", columnGap: 10 }}>

            <svg style={{ color: "red" }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
              strokeWidth="1.5" stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 6.75v10.5a2.25 2.25 0 0 0 2.25 2.25Zm.75-12h9v9h-9v-9Z" />
            </svg>

            <h1 className="text-md font-bold" style={{ color: "red" }}>Users with Basic Plan are not allowed to access this section.</h1>
          </div>
        </div> : null}


      {user.pricing == "Pro" || user.pricing == "Enterprise" ?
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
              <div className="flex flex-col  mb-2">

                <div>
                  <h2 className="text-md font-bold mb-2">Bot Status</h2>
                  <div className="flex items-center space-x-2" style={{ marginBottom: 15, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth=".5" stroke="currentColor" className="size-20">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M14.25 9v6m-4.5 0V9M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    <div>
                      <h3 className="text-lg font-bold mb-1" style={{ color: "red" }}>Stopped...</h3>
                      <h3 style={{ color: "grey" }} className="text-sm mb-1">(Click on pause to stop it.)</h3>
                    </div>
                  </div>
                  <hr></hr>
                  <h3 className="text-md font-semibold mb-4" style={{ marginTop: 20 }}>Bot Configuration</h3>
                  <div className="space-y-6">


                    <div>
                      <label className="block text-xs font-medium text-gray-700 dark:text-gray-300">
                        Step 1: Define amount for each trade ($USD):
                      </label>
                      <input
                        type="text"
                        className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 px-3 py-2 text-gray-900 dark:text-gray-100"
                        value={amountForEachTrade}
                        placeholder="500"
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-medium text-gray-700 dark:text-gray-300">
                        Step 2: Define maximum daily loss ($USD):
                      </label>
                      <input
                        type="text"
                        className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 px-3 py-2 text-gray-900 dark:text-gray-100"
                        value={maxDailyLoss}
                        placeholder="500"
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-medium text-gray-700 dark:text-gray-300">
                        Step 3: Your Binance API Key:
                      </label>
                      <input
                        type="text"
                        className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 px-3 py-2 text-gray-900 dark:text-gray-100"
                        value={apiKey}
                        placeholder="Enter your Binance API Key"
                      />
                    </div>
                     <div>
                      <label className="block text-xs font-medium text-gray-700 dark:text-gray-300">
                        Step 4: Your Binance API Secret:
                      </label>
                      <input
                        type="text"
                        className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 px-3 py-2 text-gray-900 dark:text-gray-100"
                        value={apiSecret}
                        placeholder="Enter your Binance API Secret"
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-medium text-gray-700 dark:text-gray-300">
                        Step 5: Whitelist IP address <b>X.X.X.X</b> in your Binance account settings.  Use this
                        <button
                          style={{ margin: 3, padding: 3 }}
                          onClick={() => openInNewTab()}
                          className="bg-primary-main hover:bg-primary-dark text-white font-medium rounded-md"
                        >
                          link
                        </button>
                        to learn more about IP whitelisting.
                      </label>

                    </div>

                    <div className="pt-1">
                      <button
                        className="bg-primary-main hover:bg-primary-dark text-white font-small py-1 px-2 rounded-md"
                        onClick={(e) => saveBotConfig(e)}
                      >
                        Save Bot Configuration
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-2"></div>
            </div>

           
          </div>
          {/* Stats card */}
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
              <h3 className="text-lg font-semibold mb-4">Trading Statistics</h3>
              <div className="space-y-4">
                <div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Signals Followed</span>
                  </div>
                  <div className="mt-1 h-2 w-full bg-gray-200 dark:bg-gray-700 rounded-full">
                    <div
                      className="h-2 bg-primary-main rounded-full"
                      style={{
                        width: `${Math.min(100, (10 / 200) * 100)}%`,
                      }}
                    ></div>
                  </div>
                </div>

                <div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Success Rate</span>
                    <span className="font-semibold">10%</span>
                  </div>
                  <div className="mt-1 h-2 w-full bg-gray-200 dark:bg-gray-700 rounded-full">

                  </div>
                </div>

                <div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Profit/Loss</span>
                    {/* <span
                    className={`font-semibold ${user.stats.profitLoss >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`}
                  >
                    $
                    {user.stats.profitLoss.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                    })}
                  </span> */}
                  </div>
                </div>

                <div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Avg Trade Time</span>
                    {/* <span className="font-semibold">{user.stats.averageTradeTime} hours</span> */}
                  </div>
                </div>
              </div>
            </div>
        </div> 
        : null}
 



      </main>







    </div>

     
     
 
  );
};

export default Profile;
